import { Grid, useElementBreakpoints } from "@compass/core";
import { FilePanel } from "components";
import { ContributorMatchFile, Permission, UploadFile } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { initDataModel } from "utils";
import { MatchFile } from "./MatchFile";

export const MatchFiles = (props: {
  rootPermission: Permission;
  id: number;
  matchFiles: ContributorMatchFile[];
  setMatchFiles: (value: ContributorMatchFile[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      {props.matchFiles.map((matchFile, index) => (
        <Grid key={index} item xs={smallFieldBreakpoints}>
          <MatchFile
            rootPermission={props.rootPermission}
            matchFile={matchFile}
            setMatchFile={(matchFile) => {
              props.setMatchFiles(
                produce(props.matchFiles, (draft) => {
                  draft[index] = matchFile;
                })
              );
            }}
            cancelCreate={() => {
              props.setMatchFiles(
                produce(props.matchFiles, (draft) => {
                  draft.splice(index, 1);
                })
              );
            }}
          />
        </Grid>
      ))}

      <Grid item xs={smallFieldBreakpoints}>
        <FilePanel
          onFileChange={(fileName, fileSize, uploadingData) => {
            const newMatchFile = initDataModel<ContributorMatchFile>({
              uploadFile: initDataModel<UploadFile>({
                fileName: fileName,
                fileSize: fileSize,
                uploadingData: uploadingData,
              }),
            });

            props.setMatchFiles(
              produce(props.matchFiles, (draft) => {
                draft.push(newMatchFile);
              })
            );
          }}
        />
      </Grid>
    </Grid>
  );
};
